export function t(value: unknown): string {
  return String(value ?? '').trim()
}

export function escapeHtml(value: unknown): string {
  return t(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
}

export function formatTime(value: unknown): string {
  const dateInput =
    typeof value === 'string' || typeof value === 'number' || value instanceof Date ? value : ''
  const date = new Date(dateInput)
  if (!Number.isFinite(date.getTime())) return '—'
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }).format(date)
}
